export const LiteraryDevicesAndThemes = {
  title: 'Literary Devices and Themes',
  icon: '/static/templates_icons/LiteraryDevicesAndThemes.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#literary-devices-themes">https://parlayideas.com/templates/#literary-devices-themes</a>]
    </p>
    <h3>Part 1 - Reading Requirements</h3>
    <p>
      This discussion will cover material from chapters <span class="pink-selectable">[chapter numbers]</span> of <span class="pink-selectable">[book name].</span>

      It is recommended that you review the discussion questions below and keep them in mind as you read the chapters.
    </p>
    <h3>Part 2 - Personal Submission</h3>
    <p>
      In your personal submission write a one to two paragraph response, answering the following questions:
    </p>
    <p>
      <strong>&emsp; 1. Choose one of the literary devices that we talked about in class (see list below),
      find an example of it in the text, and share it in your response (including the page
      number) along with a brief explanation of why this is an example of your chosen
      device.</strong>
    </p>
    <p>
      <strong>&emsp; List of Literary Devices:</strong> Allegory, Allusion, Conflict, Diction, Foreshadowing, Hyperbole,
      Imagery, Metaphor/Simile, Mood, Personification, Plot, Point of View, Stream of
      Consciousness, Symbol, Tone.
    </p>
    <p>
      <span class="pink-selectable">&emsp;[Teacher to edit this list as necessary.]</span>
    </p>
    <p>
      <strong>&emsp; 2. How does the author use this device to connect back to one of the broader themes
      of the story?</strong>
    </p>
    <h3>Part 3 - Peer Feedback</h3>
    <p>
      After you've submitted your response, comment on at least <span class="pink-selectable">two</span> of your peers' submissions,
      answering the guided feedback questions provided. Try your best to comment on submissions
      that don’t yet have any feedback.
    </p>
  `,
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/LiteraryDevicesThemes.js